import { Panel } from "@mixitone/components/Controls";
import { ApplicationView } from "@mixitone/mvc";
import { formatDate, sanitizeClubMessageHtml } from "@mixitone/util";
import { ClubDetailsPageController } from "controllers/ClubDetailsPageController";

export const ClubUpdatesPanel = ApplicationView(() => {
  const controller = ClubDetailsPageController.use();
  const { clubMessages, loadingMessages } = controller.state;

  if (loadingMessages || clubMessages.length === 0) {
    return null;
  }

  return (
    <Panel title="Updates from the club" titleClassName="font-semibold">
      <ul className="flex flex-col gap-4">
        {clubMessages.map((m) => {
          const when = m.updated_at ?? m.created_at;
          return (
            <li key={m.uniqueId} className="flex flex-col gap-1">
              {when ? <span className="text-xs tabular-nums text-slate-500">{formatDate(when)}</span> : null}
              <div
                className="prose prose-sm max-w-none text-sm text-slate-900 [&_a]:text-slate-900 [&_ol]:my-2 [&_ul]:my-2 [&_p]:my-1"
                // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized via sanitizeClubMessageHtml
                dangerouslySetInnerHTML={{ __html: sanitizeClubMessageHtml(m.body ?? "") }}
              />
            </li>
          );
        })}
      </ul>
    </Panel>
  );
});
